<template>
	<v-container class="noMargin">		
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>ROLES</h2>					
				</div>	
				<v-btn @click.prevent="fncRoleAdd" class="elevation-5" color="info"><i class="material-icons">add</i>Create Role</v-btn>
				<v-btn @click.prevent="fncReloadRoles" class="elevation-5" color="info"><i class="material-icons">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		},
		methods: {
			fncRoleAdd() {
				var modalDetails = { title: 'Add Role', component: 'modal-role-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadRoles() {
            this.$store.commit('fncEmptyRoles');
            this.$store.dispatch({
              type: 'fncPopulateRoles',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>